import React, {useRef} from 'react'

import Task from "../../../model2/task/task"
import PopoverMenuOption from "../../../gd-components/popover-menu/popover-menu/menu-option"
import {MenuOption, PopoverMenuItemType} from "../../../gd-components/popover-menu/popover-menu/const"
import PopoverMenuSeparator from "../../../gd-components/popover-menu/popover-menu/popover-menu-separator"
import {taskMore_initActions} from "./actions/actions"
import ItemId from "../../id/item-id"
import ControlButtonStandard, {
    ControlButtonType
} from "../../../gd-components/buttons/control-button/control-button-standard"
import Pin from "../../../gd-components/pin/v2/pin"
import taskMore_getMoveOptions from "./functions/get-move-options"
import {TaskAction} from "./@const"
import {taskMore_initCreateReminder} from "./actions/create-reminder"
import {taskMore_initRecurrence} from "./actions/recurrence"
import {taskMore_initDuplicate} from "./actions/duplicate"
import {taskMore_initChangeStatus} from "./actions/change-status"
import {taskMore_initTimeTracking} from "./actions/time-tracking"
import PopoverMenuOptionWithSubmenu
    from "../../../gd-components/popover-menu/popover-menu/option-with-submenu/menu-option-with-submenu"
import PopoverMenuOptionWithCustomPopover
    from "../../../gd-components/popover-menu/popover-menu/option-with-custom-popover/menu-option-with-custom-popover"
import {taskMore_initSaveAsTemplate} from "./actions/save-as-template"
import {taskMore_initShareAsTicket} from "./actions/share-as-ticket"

export type TaskMore_PopoverMenuProps = {
    task                : Task

    hiddenActions?      : TaskAction[],
    disabledActions?    : string[]
    customOptions?      : any[]

    showOpen?           : boolean
    hideMove?           : boolean

    hidePopover         : func

    onMove?             : func  // not in use po hodu
    onDelete?           : func

    // for future not in use at the moment - i.e. lock dates in gant view
    onLockDates?        : func
    onUnlockDates?      : func
}

export default function TaskMorePopoverMenu(props: TaskMore_PopoverMenuProps) {

    // Validate data for task more popover
    props.task.checkDataForMorePopover()

    const selfRef: any = useRef()

    const onClickCopyLink = () => {
        props.hidePopover()
        props.task.copyUrl()
    }

    const onClickMinimizeToTRay = () => {
        props.hidePopover()
        props.task.minimizeToTRay()
    }

    const onClickOpenNewWindow = () => {
        props.hidePopover()
        props.task.openNewWindow()
    }

    const onClickRename = () => {
        props.hidePopover()
        props.task.rename()
    }

    const onClickLockDates = () => {
        if (props.onLockDates) props.onLockDates()
    }

    const onClickUnlockDates = () => {
        if (props.onUnlockDates) props.onUnlockDates()
    }

    const onClickConvert = () => {
        gd.modals.task.convertTaskType(props.task, (taskType, taskStatus)=>{
            const data: any = {
                id          : props.task.id,
                taskTypeId  : taskType
            }
            if (taskStatus) data.statusId = taskStatus

            // if (props.onEdit) props.onEdit(data)

        })
    }

    const onClickDelete = () => {
        gd.modals.task.deleteTask(props.task, (data:any)=>{
            if (!(data && data.hasOwnProperty("deleteInProgress")) && props.onDelete) {
                props.onDelete()
            }
        })
    }

    let menuOptions : MenuOption[] = []

    const project           = gd.session.projects.get(props.task.projectId ? props.task.projectId : props.task.parentId);
    const isTemplate        = project ? project.isTemplate : false;
    const isFullAccess      = gd.ac.check.project.fullAccess(props.task.projectId);
    // const isStandardAccess  = gd.ac.check.project.standardAccess(props.task.projectId);

    // init taskSystemType
    // const taskSystemType = _.get(props.task, 'systemType', gd.const.task.systemType.TASK)

    const disableRename = !props.task.acl.canRename

    menuOptions.push({
        icon        : "i5-pen",
        label       : "Rename",
        disabled    : disableRename,
        onClick     : onClickRename,
    })

    //currently for gantt only
    if (isFullAccess) {
        if (props.onLockDates) {
            menuOptions.push({
                icon    : "i5-lock",
                label   : "Lock dates",
                onClick : onClickLockDates,
            })
        } else if (props.onUnlockDates) {
            menuOptions.push({
                icon    : "i5-lock",
                label   : "Unlock dates",
                onClick : onClickUnlockDates,
            })
        }
    }

    if (!props.hideMove) {
        const moveDisabled = isTemplate
            || props.disabledActions?.includes('move')
            || (
                !props.task.acl.canMove
                && !props.task.acl.canAddProject
            )
        menuOptions.push({
            type        : PopoverMenuItemType.SUBMENU,
            icon        : 'i5-move-to',
            label       : gd.company.settings.labs.multipleTaskProjectsSupport ? 'Move / Add' : 'Move',
            options     : taskMore_getMoveOptions(props.task, props.hidePopover, props.onMove),
            disabled    : moveDisabled,
        })
    }

    menuOptions.push({
        icon        : "i5-task-types",
        label       : "Change task type",
        onClick     : onClickConvert,
        disabled    : props.disabledActions?.includes('change-type') || !props.task.acl.canChangeType,
    })


    taskMore_initChangeStatus(props, menuOptions)

    taskMore_initTimeTracking(props, menuOptions)

    if (
        !props.hiddenActions?.includes(TaskAction.DUPLICATE)
        || !props.hiddenActions?.includes(TaskAction.EDIT_RECURRENCE)
        || !props.hiddenActions?.includes(TaskAction.CREATE_REMINDER)
    ) {
        menuOptions.push({ type: PopoverMenuItemType.SEPARATOR})
    }

    // Actions (automations available for this task)
    taskMore_initActions(props, menuOptions)

    // Reminder
    taskMore_initCreateReminder(props, menuOptions)

    // Duplicate
    taskMore_initDuplicate(props, menuOptions)

    // Recurrence
    taskMore_initRecurrence(props, menuOptions, isTemplate)

    // Share as ticket
    taskMore_initShareAsTicket(props, menuOptions)

    if (props.customOptions) {
        menuOptions.push({ type: PopoverMenuItemType.SEPARATOR})
        menuOptions = menuOptions.concat(props.customOptions);
    }

    // Save as Template
    taskMore_initSaveAsTemplate(props, menuOptions)

    // DELETE
    menuOptions.push({ type: PopoverMenuItemType.SEPARATOR})
    menuOptions.push({
        icon        : "i5-trash-alt ui5-color-red",
        label       : "Delete",
        disabled    : !props.task.acl.canDelete || props.disabledActions?.includes('delete'),
        onClick     : onClickDelete
    })

    return (
        <div ref={selfRef} className="ui5-popover-menu min-w-275">
            <div className="flex-row-between-center h-36 m-t-5 p-l-20 p-r-10">
                <ItemId
                    className   = "gd-popup-menu-btn"
                    itemId      = {props.task.shortId}
                    itemUrl     = "t/"
                    itemUrlId   = {props.task.id}
                    itemName    = "Task"
                    copyId      = {true}
                    copyUrl     = {true}
                />

                <div className="flex-row-center-center">
                    <Pin
                        hint    = "Pin task to a workspace"
                        data    = {{taskId: props.task.id}}
                    />

                    <ControlButtonStandard
                        className   = "m-l-5"
                        type        = {ControlButtonType.LINK}
                        hint        = "Copy link"
                        onClick     = {onClickCopyLink}
                    />

                    <ControlButtonStandard
                        className   = "m-l-5"
                        type        = {ControlButtonType.TRAY}
                        hint        = "Move task to tray"
                        onClick     = {onClickMinimizeToTRay}
                    />
                    <ControlButtonStandard
                        className   = "m-l-5"
                        type        = {ControlButtonType.OPEN_IN_BROWSER}
                        hint        = "Open in new window"
                        onClick     = {onClickOpenNewWindow}
                    />
                </div>
            </div>


            {_.map(menuOptions, (menuOption: any, key) => {
                if (menuOption.type === PopoverMenuItemType.SEPARATOR) {
                    return <PopoverMenuSeparator key={key}/>
                }

                if (menuOption.type === PopoverMenuItemType.SUBMENU) {
                    return (
                        <PopoverMenuOptionWithSubmenu
                            key     = {key}
                            option  = {menuOption}
                        />
                    )
                }

                if (menuOption.type === PopoverMenuItemType.CUSTOM_POPOVER) {
                    return (
                        <PopoverMenuOptionWithCustomPopover
                            key         = {key}
                            menuParams  = {menuOption.menuParams}
                            option      = {menuOption}
                        />
                    )
                }

                return (
                    <PopoverMenuOption
                        key             = {key}
                        option          = {menuOption}
                        checkPro        = {menuOption.isPro}
                        onClickUpgrade  = {menuOption.onClickUpgrade}
                        hidePopover     = {props.hidePopover}
                    />
                )
            })}
        </div>
    )
}
